import styled from 'styled-components';
import React from 'react';
import { IoIosCheckmark } from 'react-icons/io';
import {
  StrapiTextual,
  StrapiTextualProps,
} from '@/features/strapi/components/textual';
import { breakpoints } from '@/components/responsive';

export interface StrapiImageTextualProps {
  textual: StrapiTextualProps;
  image?: string;
  gap?: string;
}

export function StrapiImageTextual({
  image,
  textual,
  gap,
}: StrapiImageTextualProps) {
  return (
    <Wrapper gap={gap}>
      {!image && (
        <>
          <IoIosCheckmark className="only-desktop" size="2.8rem" />
          <IoIosCheckmark className="only-mobile" size="2rem" />
        </>
      )}
      {image && <img src={image} alt="" />}
      <StrapiTextual {...textual} />
    </Wrapper>
  );
}

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: ${(props: { gap?: string }) => props.gap || `0.5rem`};
  align-items: center;

  ${breakpoints.down(`md`)} {
    grid-gap: calc(${(props: { gap?: string }) => props.gap || `0.5rem`} * 0.7);
  }

  img {
    height: 3rem;
    width: auto;
    ${breakpoints.down(`md`)} {
      height: 2rem;
    }
  }

  && > a {
    text-align: start;
  }
`;
